export default __webpack_public_path__ + "static/media/eligibility_iat.655ab1d5.svg";